/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateExternalApiKeyV1Dto } from '../models/CreateExternalApiKeyV1Dto';
import type { ExternalApiKeyV1Dto } from '../models/ExternalApiKeyV1Dto';
import type { ExternalApiKeyValidationV1Dto } from '../models/ExternalApiKeyValidationV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExternalApiKeyService {
  /**
   * @param requestBody
   * @returns CreateExternalApiKeyV1Dto create entity
   * @throws ApiError
   */
  public static externalApiKeyControllerV1CreateV1(
    requestBody: CreateExternalApiKeyV1Dto,
  ): CancelablePromise<CreateExternalApiKeyV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/external-api-key',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param keyType
   * @returns ExternalApiKeyV1Dto
   * @throws ApiError
   */
  public static externalApiKeyControllerV1FindLatestApiKeyV1(
    keyType: 'Brevo' | 'YouSign',
  ): CancelablePromise<ExternalApiKeyV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/external-api-key',
      query: {
        keyType: keyType,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param id
   * @returns ExternalApiKeyV1Dto the entity
   * @throws ApiError
   */
  public static externalApiKeyControllerV1DeleteV1(
    id: string,
  ): CancelablePromise<ExternalApiKeyV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/external-api-key/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param id
   * @returns ExternalApiKeyV1Dto the entity
   * @throws ApiError
   */
  public static externalApiKeyControllerV1FindV1(
    id: string,
  ): CancelablePromise<ExternalApiKeyV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/external-api-key/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param id
   * @returns ExternalApiKeyValidationV1Dto
   * @throws ApiError
   */
  public static externalApiKeyControllerV1ValidateV1(
    id: string,
  ): CancelablePromise<ExternalApiKeyValidationV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/external-api-key/validate/{id}',
      path: {
        id: id,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
}
